/**
 * Layout component that queries for data
 * with Gatsby's useStaticQuery component
 *
 * See: https://www.gatsbyjs.com/docs/use-static-query/
 */

import React from "react"
import PropTypes from "prop-types"
import { useStaticQuery, graphql } from "gatsby"

import Header from "./header"
import "./layout.css"

const Layout = ({ children,lang='en' }) => {
  const data = useStaticQuery(graphql`
    query SiteTitleQuery {
      site {
        siteMetadata {
          title
        }
      }
    }
  `)

if(lang!=='ar' && lang!=='zh'){
  return (
    <>
      <Header siteTitle={data.site.siteMetadata?.title || `Title`} lang={lang} />
      <div
       
      >
        <main>{children}</main>
        <div className="clearfix ">&nbsp;</div>
        {/* <footer style={{
          marginTop: `2rem`
        }}>
          © {new Date().getFullYear()}, Built with
          {` `}
          <a href="https://www.unesco.com">Unesco</a>
        </footer> */}
      </div>
    </>
  )

      }else{

        if(lang=='ar'){
                return (
                  <>
                    <Header siteTitle={data.site.siteMetadata?.title || `Title`} lang={lang} />
                    <div
                    className="rtl"
                    >
                      <main>{children}</main>
                      <div className="clearfix ">&nbsp;</div>
                      {/* <footer style={{
                        marginTop: `2rem`
                      }}>
                        © {new Date().getFullYear()}, Built with
                        {` `}
                        <a href="https://www.unesco.com">Unesco</a>
                      </footer> */}
                    </div>
                  </>
                )
              }
              if(lang=='zh'){
                return (
                  <>
                    <Header siteTitle={data.site.siteMetadata?.title || `Title`} lang={lang} />
                    <div
                    className="zh"
                    >
                      <main>{children}</main>
                      <div className="clearfix ">&nbsp;</div>
                      {/* <footer style={{
                        marginTop: `2rem`
                      }}>
                        © {new Date().getFullYear()}, Built with
                        {` `}
                        <a href="https://www.unesco.com">Unesco</a>
                      </footer> */}
                    </div>
                  </>
                )
              }

      }
}

Layout.propTypes = {
  children: PropTypes.node.isRequired,
}

export default Layout
